<section class="menu-buttons-page" [ngStyle]="{'background': getBackgroundStyle()}">
  <div class="menu-buttons-header">
    <menu-buttons-header [label]="label"></menu-buttons-header>
  </div>
  <div class="menu-buttons-page__card">
    <div class="menu-buttons-page__content">
      <menu-buttons [topActions]="topActions" (actionClick)="onActionClick($event)"></menu-buttons>
    </div>
  </div>
</section>
